import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

const LABELS: Record<string, string> = {
  account_created: "Account created",
  login_success: "Logged in",
  login_failed: "Login failed",
  logout: "Logged out",
  logout_all: "Logged out everywhere",
  phone_added: "Phone added",
  phone_verified: "Phone verified",
  phone_verify_failed: "Phone verification failed",
  sms_consent_granted: "SMS consent granted",
  simulated_message_received: "Inbound SMS received",
  simulated_message_sent: "Outbound SMS sent",
  job_created: "Job created",
  job_claimed: "Job claimed",
  job_completed: "Job completed",
  job_failed: "Job failed",
  agent_run_started: "Remy started working",
  agent_run_completed: "Remy finished",
  agent_run_paused: "Waiting for your approval",
  agent_run_resumed: "Resumed after approval",
  agent_run_failed: "Remy stopped (safe)",
  permission_decision: "Permission decision",
  tool_executed: "Tool ran",
  action_executed: "Approved action executed",
  approval_requested: "Approval requested",
  approval_failed: "Wrong approval code",
  approval_rejected: "Approval rejected",
  approval_edited: "Approval edited",
  approval_integrity_failed: "Action changed — blocked",
  memory_saved: "Memory saved",
  memory_updated: "Memory updated",
  memory_forgotten: "Memory forgotten",
  task_created: "Task created",
  task_transition: "Task updated",
  task_transition_rejected: "Task change blocked",
  sms_opt_out: "Opted out (STOP)",
  sms_opt_in: "Opted back in (START)",
};

export default function ActivityPage() {
  const [logs, setLogs] = useState<any[]>([]);

  useEffect(() => {
    api.get("/activity").then((r) => setLogs(r.data)).catch((e) => toast.error(apiError(e)));
  }, []);

  return (
    <div data-testid="activity-page">
      <h1 className="font-display text-2xl font-semibold tracking-tight">Activity</h1>
      <p className="text-sm text-muted-foreground">Append-only audit log for your account.</p>

      <div className="mt-5 space-y-2">
        {logs.length === 0 && <p className="text-sm text-muted-foreground">No activity yet.</p>}
        {logs.map((lg) => (
          <div key={lg.id} className="rounded-2xl border border-border bg-card p-4" data-testid={`activity-${lg.event_type}`}>
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium">{LABELS[lg.event_type] || lg.event_type}</span>
              <span className={`text-[11px] font-medium ${lg.status === "ok" ? "text-muted-foreground" : "text-destructive"}`}>
                {lg.actor_type} · {lg.status}
              </span>
            </div>
            <p className="mt-1 text-xs text-muted-foreground">{lg.summary}</p>
            <p className="mt-1 text-[11px] text-muted-foreground">{new Date(lg.created_at).toLocaleString()}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
